import React from "react";
import videojs from "video.js";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Video from "./Video";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { addTagModal, logInModal, setLocation, yourTrailsModal, shareModal, tagArrayUpdated, updatesModal } from "../redux/modalSlice";
import { useDispatch, useSelector } from "react-redux";
import { useDeleteTrailPostMutation, useFavouritePostMutation, useUnFavouritePostMutation } from "../API/trailAPI";
import { useEffect } from "react";
import { useState } from "react";
import { useDownVotePostMutation, useSharePostMutation, useUpVotePostMutation } from "../API/postAPI";
import { useAddTagMutation } from "../API/tagAPI";
import { config } from "../config";
import { toast } from "react-toastify";
import { AES } from "crypto-js";

const Card = ({ post, showTags, isDelete, trailId, showAddYourHashTag = true }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const playerRef = React.useRef(null);
  const [favourite, setFavourite] = useState(post?.favorite);
  const [updates, setUpdates] = useState(post?.updates);
  const [tagArray, setTagArray] = useState(showTags ? post.tags : post.tagstats);
  const [tagChange, setTagChange] = useState(false);
  const [favouritePost, { data: favouritePostData, isLoading, isSuccess, isError, error }] = useFavouritePostMutation();
  const [unFavouritePost, { data: unFavouritePostData, isLoading: unFavouritePostIsLoading, isSuccess: unFavouritePostIsSuccess, isError: unFavouritePostIsError, error: unFavouritePostError }] = useUnFavouritePostMutation();
  const [upVotePost, { data: upVotePostTagData, isLoading: upVotePostTagIsLoading, isSuccess: upVotePostTagIsSuccess, isError: upVotePostTagIsError, error: upVotePostTagError }] = useUpVotePostMutation();
  const [downVotePost, { data: downVoteData, isLoading: downVoteIsLoading, isSuccess: downVoteIsSuccess, isError: downVoteIsError, error: downVoteError }] = useDownVotePostMutation();
  // const searchText = useSelector((state) => state.modal.searchText);
  const [searchParams, setSearchParams] = useSearchParams();
  const searchText = searchParams.get("query") || "";
  const tagArrayUpdatedState = useSelector((state) => state.modal.tagArrayUpdated);
  const [addTag, { data: addedTags, isLoading: addedTagsIsLoading, isSuccess: addedTagsIsSuccess, isError: addedTagsIsError, error: addedTagsError }] = useAddTagMutation();
  const [sharePost, { data: sharePosts, isLoading: sharePostIsLoading, isSuccess: sharePostIsSuccess, isError: sharePostIsError, error: sharePostError }] = useSharePostMutation();
  const [deleteTrailPost, { data: deleteTrailPostData, isLoading: deleteTrailPostIsLoading, isSuccess: deleteTrailPostIsSuccess, isError: deleteTrailPostIsError, error: deleteTrailPostError }] = useDeleteTrailPostMutation();

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    // You can handle player events here, for example:
    player.on("waiting", () => {
      videojs.log("player is waiting");
    });
    player.on("play", (play) => {
      player.pauseOtherPlayers = true;
      // console.log(":: play :: ", play);
      var medias = Array.prototype.slice.apply(document.querySelectorAll("audio,video"));
      medias.forEach(function (media) {
        media.addEventListener("play", function (event) {
          medias.forEach(function (media) {
            if (event.target != media) media.pause();
          });
        });
      });
    });
    // player.on("mouseenter", () => {
    //   videojs.log("player is waiting enter", player);
    //   player.bigPlayButton.handleClick();
    // });
    // player.on("mouseleave", function () {
    //   videojs.log("player is waiting leave", player);
    //   player.pause();
    //   player.bigPlayButton.show();
    // });
    player.on("dispose", () => {
      videojs.log("player will dispose");
    });
  };

  const updateTagStats = (data) => {
    let { postId, tag } = data;
    const tmpTagArray = tagArray.map((tagI) => {
      if (tagI.tag_name === tag) {
        return tagI.user_vote ? { ...tagI, count: tagI.count - 1, user_vote: !tagI.user_vote } : { ...tagI, count: tagI.count + 1, user_vote: !tagI.user_vote }; // Using object spread syntax to update the 'count' value
      }
      return tagI;
    });
    setTagArray(tmpTagArray);
  };

  const addNewTag = () => {
    // alert(tagArrayUpdatedState);
    const tagList = localStorage.getItem("tagList") ? JSON.parse(localStorage.getItem("tagList")) : undefined;
    const postId = localStorage.getItem("postId") ? JSON.parse(localStorage.getItem("postId")) : undefined;
    const tmpTagArray = [...tagArray];

    if (tagList && tagList.length > 0 && post?.id === postId) {
      tagList.forEach((tag) => {
        tmpTagArray.push({ tag_name: tag.post_tag, owned: 1, user_vote: 0, count: 0 });
      });
      localStorage.removeItem("tagList");
      localStorage.removeItem("postId");
    }
    setTagArray(tmpTagArray);
    dispatch(tagArrayUpdated(false));
  };

  const handleModalOpens = (choice, postId) => {
    //case 1= add your tag, case 2= trail modal case 3 =favouritepost case 4=postdetail
    // // console.log("token from post card ::", { token, choice, postId });
    if (token !== null && token !== "" && token !== undefined) {
      switch (choice) {
        case 1:
          dispatch(addTagModal({ modal: true, postId }));
          break;
        case 2:
          dispatch(yourTrailsModal({ modal: true, postId }));
          break;
        case 3:
          favouritePost({ post_id: postId });
          setFavourite(true);
          break;
        case 4:
          navigate(`/post-details/${encodeURIComponent(AES.encrypt(post?.id.toString(), config.passphrase).toString())}`);
          break;
        case 5:
          //handle tag search
          // dispatch(handleChangeSearchText(postId));
          updateTagStats(postId);
          if (postId.user_vote) {
            dispatch(downVotePost({ post_id: postId.postId, tag: postId.tag }));
          } else {
            dispatch(upVotePost({ post_id: postId.postId, tag: postId.tag }));
          }
          break;
        case 6:
          dispatch(setLocation(postId));
          break;
        case 7:
          unFavouritePost({ post_id: postId });
          setFavourite(false);
          break;
        case 8:
          // sharePost({ post_id: postId.postId });
          dispatch(shareModal({ modal: true, postId: postId.postId, shareLink: postId.shareLink }));
          break;
        case 9:
          // dispatch(updatesModal({ modal: true, postId })); commented
          break;
        default:
          break;
      }
    } else {
      dispatch(logInModal(true));
    }
  };

  useEffect(() => {
    if (tagArrayUpdatedState) {
      addNewTag();
    }
  }, [tagArrayUpdatedState]);

  const deletePostFromTrail = (postId) => {
    deleteTrailPost({ trail_id: parseInt(trailId), post_id: postId });
  };

  useEffect(() => {
    if (deleteTrailPostIsSuccess) {
      if (deleteTrailPostData.status === 200) {
        toast(deleteTrailPostData.message, {
          ...config.toast_config,
          type: "success",
        });
        navigate(0);
      } else {
        toast(deleteTrailPostData.message, {
          ...config.toast_config,
          type: "error",
        });
      }
    }
  }, [deleteTrailPostData, deleteTrailPostIsSuccess]);

  return (
    <div
      className="trail_post cursor-pointer"
    // onClick={() => handleModalOpens(4, post?.id)}
    >
      {post?.reason ? (
        <div className="error_video">
          {/* <p className="text-danger">Why is rejected?</p> */}
          <p>{post?.reason}</p>
        </div>
      ) : (
        ""
      )}
      <div className="trail_post_user">
        <div className="user_img">
          <Link to="#">
            <img src={post?.profile_image} alt="" title="" />
          </Link>
        </div>

        <h4 className="d-inline-block text-truncate">
          <Link to={post?.slug ? `/post-details/${post?.slug}` : "#"}>{post?.post_name}</Link>
          <span className={post?.status === "Pending" ? "badge bg-warning text-light float-end" : post?.status === "Rejected" ? "badge bg-danger text-light float-end" : "badge bg-success text-light float-end"}>{post?.status}</span>
          {isDelete && (
            <span
              className="float-end"
              title="Delete post from trail"
              onClick={() => {
                if (window.confirm("Are you sure you want to remove this place from trail?")) {
                  deletePostFromTrail(post?.id);
                } else {
                  // do not delete the item
                }
              }}
            >
              <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.49967 0.5V1.33333H0.333008V3H1.16634V13.8333C1.16634 14.2754 1.34194 14.6993 1.6545 15.0118C1.96706 15.3244 2.39098 15.5 2.83301 15.5H11.1663C11.6084 15.5 12.0323 15.3244 12.3449 15.0118C12.6574 14.6993 12.833 14.2754 12.833 13.8333V3H13.6663V1.33333H9.49967V0.5H4.49967ZM2.83301 3H11.1663V13.8333H2.83301V3ZM4.49967 4.66667V12.1667H6.16634V4.66667H4.49967ZM7.83301 4.66667V12.1667H9.49967V4.66667H7.83301Z" fill="#DD1010"></path>
              </svg>
            </span>
          )}
        </h4>

        <p>
          <Link to={"/posts?query=" + post?.category?.category_name} className="float-start">
            {post?.category?.category_name}
          </Link>
          <Link
            href="#"
            onClick={(e) => {
              e.stopPropagation();
              handleModalOpens(6, `${post?.city}, ${post?.state}, ${post?.country}`);
            }}
            className="float-end"
          >
            <span>
              <i className="fas fa-map-marker-alt"></i>&nbsp;
              {post?.city}, {post?.state}, {post?.country}
            </span>
          </Link>
        </p>
      </div>
      <div className="trail_post_img">
        {/* <OwlCarousel
          className="owl-theme"
          loop={true}
          nav={true}
          dots={true}
          navText={[
            '<span className="arrow prev">â€¹</span>',
            '<span className="arrow next">â€º</span>',
          ]}
          responsive={{
            0: {
              items: 1,
            },
            480: {
              items: 1,
            },
            768: {
              items: 1,
            },
            1152: {
              items: 1,
            },
          }}
        >
          <div className="item"> */}
        {post?.hasVideo ? (
          post?.media && post?.media?.length ? (
            post?.media.map((media, index) =>
              media.type === 2 ? (
                <Video
                  key={"media_" + index + media.id}
                  options={{
                    preload: "auto",
                    autoplay: false,
                    controls: true,
                    responsive: true,
                    fluid: true,
                    sources: [
                      {
                        src: `${media?.media_name}`,
                        type: "application/x-mpegURL",
                      },
                    ],
                    poster: `${media.thumbnail_img}`,
                  }}
                  onReady={handlePlayerReady}
                />
              ) : (
                // <img src={`${media?.media_name}`} alt="" title="" className="video_play" />
                ""
              )
            )
          ) : (
            ""
          )
        ) : post?.media && post?.media?.length ? (
          <div>
            <img src={post?.media[0]?.media_name} alt={post?.media[0]?.media_name} title={post?.media[0]?.media_name} className="img-fluid" />
          </div>
        ) : (
          ""
        )}
        {/* </div> */}
        {/* </OwlCarousel> */}
      </div>
      <div className="post_detail">
        <Link
          className={showAddYourHashTag ? "d-inline-block " : "d-none"}
          to="#"
          onClick={(e) => {
            e.stopPropagation();
            handleModalOpens(1, post?.id);
          }}
        >
          <span className="badge">Add your #</span>
        </Link>

        <div className={post?.status === "Pending" || post?.status === "Rejected" ? "d-none" : "trail_tag_like"}>
          <Link
            to="#"
            onClick={(e) => {
              e.stopPropagation();
              handleModalOpens(8, { postId: post?.id, shareLink: post?.share_link });
            }}
            // to="#sharepost"
            // data-bs-toggle="modal"
            // data-bs-target="#sharepost"
            className="social_icon"
          >
            {/* <img src={require("../assets/images/share.svg")} alt="" title="" /> */}
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.81818 2.00002L6.90909 4.90911H9.09091V11.4546H10.5455V4.90911H12.7273M14.1818 18H5.45455C4.64727 18 4 17.3455 4 16.5455V7.8182C4 7.43243 4.15325 7.06246 4.42603 6.78968C4.69881 6.5169 5.06878 6.36366 5.45455 6.36366H7.63636V7.8182H5.45455V16.5455H14.1818V7.8182H12V6.36366H14.1818C14.5676 6.36366 14.9376 6.5169 15.2103 6.78968C15.4831 7.06246 15.6364 7.43243 15.6364 7.8182V16.5455C15.6364 16.9312 15.4831 17.3012 15.2103 17.574C14.9376 17.8468 14.5676 18 14.1818 18Z"
                fill="#66737F"
              />
            </svg>
          </Link>
          <Link
            to="#"
            onClick={(e) => {
              e.stopPropagation();
              handleModalOpens(2, post?.id);
            }}
            // data-bs-toggle="modal"
            // data-bs-target="#traipopup"
            className="social_icon"
          >
            {/* <img
              src={require("../assets/images/trails.svg")}
              alt=""
              title=""
              height="18"
            /> */}
            {/* <img src={require("../assets/images/trail.svg")} alt="" title="" /> */}
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.0833 3.33333C11.1666 3.41667 11.1666 3.41667 11.1666 4C11.1666 4.25 11.1666 4.5 11.1666 4.58333C11.1666 4.58333 11.4999 4.58333 13.4166 4.66667H15.5833L16.0833 5.25C16.4999 5.58333 16.6666 5.83333 16.6666 5.83333C16.6666 5.83333 16.4999 6.08333 16.1666 6.5L15.6666 7.08333H13.4999C11.5833 7.08333 11.2499 7.08333 11.2499 7.16667C11.2499 7.16667 11.2499 7.58333 11.2499 8.16667C11.2499 9 11.2499 9.08333 11.2499 9.16667C11.2499 9.16667 11.3333 9.25 11.9166 9.25H12.5833L12.6666 9.16667C12.7499 9.25 12.7499 9.25 12.7499 10.3333C12.7499 11.0833 12.7499 11.5 12.7499 11.5C12.5833 11.6667 12.5833 11.6667 11.8333 11.6667C11.3333 11.6667 11.1666 11.6667 11.1666 11.6667C11.1666 11.6667 11.1666 12.25 11.1666 14.0833V16.5L11.0833 16.5833V16.6667H9.99995H8.99995L8.91661 16.5833L8.83328 16.5V14.1667C8.83328 12.3333 8.83328 11.75 8.83328 11.75C8.83328 11.75 8.24995 11.75 6.58328 11.75H4.41661L3.91661 11.1667C3.58328 10.75 3.33328 10.5 3.33328 10.4167V10.3333C3.33328 10.3333 3.58328 10 3.83328 9.66667L4.33328 9.08333H6.49995C8.49995 9.08333 8.66661 9.08333 8.74995 9.08333C8.83328 9.08333 8.83328 9 8.83328 8.08333C8.83328 7.25 8.83328 7.16667 8.83328 7.08333C8.83328 7.08333 8.66661 7.08333 8.16661 7.08333C7.58328 7.08333 7.49995 7.08333 7.41661 7H7.33328V5.83333V4.66667L7.41661 4.58333L7.49995 4.5H8.16661C8.74995 4.5 8.83328 4.5 8.83328 4.5C8.83328 4.5 8.83328 4.41667 8.83328 3.91667C8.83328 3.41667 8.83328 3.41667 8.91661 3.33333H8.99995H9.99995H11.0833ZM11.7499 1.66667H11.0833H9.99995H8.99995H8.24995L7.74995 2.16667V2.25C7.49995 2.41667 7.33328 2.66667 7.33328 2.91667H6.74995L6.24995 3.33333V3.41667L6.16661 3.5L5.66661 4V4.66667V5.83333V7V7.5H4.33328H3.58328L3.08328 8L2.58328 8.58333C1.99995 9.25 1.83328 9.41667 1.74995 9.66667C1.58328 10.1667 1.58328 10.6667 1.83328 11.1667C1.91661 11.3333 1.91661 11.4167 2.58328 12.1667L3.08328 12.75L3.66661 13.3333H4.41661H6.58328C6.74995 13.3333 6.91661 13.3333 7.16661 13.3333C7.16661 13.6667 7.16661 13.9167 7.16661 14.1667V16.5833V17.25L7.66661 17.75L7.74995 17.8333L7.83328 17.9167L8.24995 18.3333H8.91661H9.99995H11.0833H11.7499L12.2499 17.8333L12.3333 17.75L12.4166 17.6667L12.9166 17.1667V16.5V14.1667C12.9166 13.9167 12.9166 13.6667 12.9166 13.3333C13.4166 13.25 13.9166 13 14.2499 12.3333C14.4166 11.9167 14.4166 11.6667 14.4166 10.5C14.4166 9.66667 14.4166 9.16667 14.3333 8.91667H15.7499H16.4999L16.9999 8.33333L17.4999 7.75C17.9999 6.91667 18.3333 6.5 18.3333 5.83333C18.3333 5.16667 17.9999 4.75 17.4166 4.08333L16.9166 3.5L16.4166 2.91667H15.6666H13.4999C13.2499 2.91667 12.9999 2.91667 12.7499 2.91667C12.6666 2.66667 12.4999 2.41667 12.3333 2.25L12.2499 2.16667L11.7499 1.66667Z"
                fill="#66737F"
              />
            </svg>
          </Link>
          <a
            href="#"
            className="social_icon"
            onClick={(e) => {
              e.stopPropagation();
              favourite ? handleModalOpens(7, post?.id) : handleModalOpens(3, post?.id);
            }}
          >
            {favourite ? (
              <i className="fas fa-heart"></i>
            ) : (
              <>
                {/* <img
                  src={require("../assets/images/heart.svg")}
                  alt="favourite-icon"
                  title=""
                /> */}
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.0834 15.4583L10.0001 15.5417L9.90841 15.4583C5.95008 11.8667 3.33341 9.49167 3.33341 7.08333C3.33341 5.41667 4.58341 4.16667 6.25008 4.16667C7.53341 4.16667 8.78341 5 9.22508 6.13333H10.7751C11.2167 5 12.4667 4.16667 13.7501 4.16667C15.4167 4.16667 16.6667 5.41667 16.6667 7.08333C16.6667 9.49167 14.0501 11.8667 10.0834 15.4583ZM13.7501 2.5C12.3001 2.5 10.9084 3.175 10.0001 4.23333C9.09175 3.175 7.70008 2.5 6.25008 2.5C3.68341 2.5 1.66675 4.50833 1.66675 7.08333C1.66675 10.225 4.50008 12.8 8.79175 16.6917L10.0001 17.7917L11.2084 16.6917C15.5001 12.8 18.3334 10.225 18.3334 7.08333C18.3334 4.50833 16.3167 2.5 13.7501 2.5Z"
                    fill="#66737F"
                  />
                </svg>

                {/* <span className="favriout_hover">
                  Added in your Favorite Trail <i className="fas fa-heart"></i>
                </span> */}
              </>
            )}
          </a>
        </div>
        <p className="post_description">{post?.description}</p>
        {post && post?.updates !== "" ? (
          <p className="trail_tips d-inline-block text-truncate" onClick={() => handleModalOpens(9, { id: post?.id, data: post?.updates })}>
            <i className="fas fa-bell me-1"></i>
            {updates}
          </p>
        ) : (
          ""
        )}
        <div className="tag_list bottom_fixed">
          {tagArray && tagArray.length
            ? tagArray.map((tag, index) => (
              <Link
                to="#"
                key={`tag-${index}`}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleModalOpens(5, { postId: post?.id, tag: tag.tag_name, user_vote: tag.user_vote });
                }}
                style={{ backgroundColor: tag.owned ? "#DAF5E3" : "#f0f3f2" }}
              >
                <span className="p-1 me-1">{tag.tag_name}</span>
                {showTags ? (
                  ""
                ) : (
                  <>
                    <span className="me-1">
                      {tag.user_vote ? (
                        <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: "sub" }}>
                          <g clipPath="url(#clip0_1463_816)">
                            <g clipPath="url(#clip1_1463_816)">
                              <path d="M5.21875 17.2287L1 17.2287L0.999999 6.09398L5.21875 6.09398L5.21875 17.2287Z" fill="#008B2A" />
                              <path
                                d="M18.2587 9.67634C18.4832 9.9751 18.6165 10.3462 18.6165 10.7478C18.6165 11.3429 18.3238 11.8707 17.8751 12.1956C18.0997 12.4944 18.233 12.8654 18.233 13.2671C18.233 13.8622 17.9407 14.3902 17.492 14.7152C17.7164 15.0139 17.8495 15.3849 17.8495 15.7864C17.8495 16.7717 17.0478 17.5733 16.0625 17.5733L10.4369 17.5733C9.51024 17.5733 8.60054 17.4084 7.73305 17.0831L6.27344 16.5357L6.27344 7.30755C7.98393 5.46701 9.54951 3.71026 9.83146 3.25899L9.83146 1.1848C9.83146 0.766761 10.1715 0.42666 10.5896 0.42666C12.3136 0.42666 13.7162 1.82929 13.7162 3.55332L13.7162 4.48893L13.1509 6.44161L17.213 6.44161C18.1983 6.44161 19 7.24325 19 8.22857C19 8.82366 18.7073 9.35139 18.2587 9.67634Z"
                                fill="#008B2A"
                              />
                            </g>
                          </g>
                          <defs>
                            <clipPath id="clip0_1463_816">
                              <rect width="20" height="20" fill="white" />
                            </clipPath>
                            <clipPath id="clip1_1463_816">
                              <rect width="18" height="18" fill="white" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 1 18)" />
                            </clipPath>
                          </defs>
                        </svg>
                      ) : (
                        <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: "sub" }}>
                          <g clipPath="url(#clip0_1463_824)">
                            <g clipPath="url(#clip1_1463_824)">
                              <path
                                d="M18.2587 9.67634C18.4832 9.9751 18.6165 10.3462 18.6165 10.7478C18.6165 11.3429 18.3238 11.8707 17.8751 12.1956C18.0997 12.4944 18.233 12.8654 18.233 13.2671C18.233 13.8622 17.9406 14.3902 17.492 14.7152C17.7164 15.0139 17.8494 15.3849 17.8494 15.7864C17.8494 16.7717 17.0478 17.5733 16.0624 17.5733L15.2709 17.5733L10.4369 17.5733C9.51031 17.5733 8.60057 17.4084 7.73306 17.0831L5.97394 16.4234L5.97394 17.2286L1 17.2286L0.999999 6.09395L5.97398 6.09395L5.97398 7.62902C7.79764 5.67559 9.53312 3.73645 9.83146 3.25899L9.83146 1.18477C9.83146 0.766727 10.1715 0.42666 10.5896 0.42666C12.3136 0.42666 13.7162 1.82925 13.7162 3.55332L13.7162 4.48893L13.1509 6.44161L17.213 6.44161C18.1983 6.44161 19 7.24325 19 8.22857C19 8.82362 18.7073 9.35136 18.2587 9.67634ZM4.91929 7.14868L2.05469 7.14868L2.05469 16.174L4.91929 16.174L4.91929 7.14868ZM17.213 7.4963L11.7475 7.4963L12.6615 4.3393L12.6615 3.55332C12.6615 2.51153 11.8886 1.64686 10.8861 1.50251L10.8861 3.36586C10.8861 3.62127 10.8861 3.823 8.29253 6.66981C7.31835 7.73909 6.33468 8.78668 5.97398 9.16953L5.97398 15.297L8.10339 16.0955C8.85211 16.3763 9.63719 16.5187 10.4369 16.5187L15.2709 16.5187L16.0625 16.5187C16.4663 16.5187 16.7948 16.1901 16.7948 15.7864C16.7948 15.3826 16.4663 15.0541 16.0625 15.0541L16.0625 13.9994L16.446 13.9994C16.8498 13.9994 17.1783 13.6709 17.1783 13.2671C17.1783 12.8633 16.8498 12.5348 16.446 12.5348L16.446 11.4801C16.4694 11.4801 16.4925 11.481 16.5156 11.4819L16.5156 11.4801L16.8295 11.4801C17.2333 11.4801 17.5618 11.1516 17.5618 10.7478C17.5618 10.3441 17.2333 10.0156 16.8295 10.0156L16.7638 10.0156L16.7638 8.96088L17.213 8.96088C17.6168 8.96088 17.9453 8.63234 17.9453 8.22857C17.9453 7.82477 17.6168 7.4963 17.213 7.4963Z"
                                fill="#374149"
                              />
                            </g>
                          </g>
                          <defs>
                            <clipPath id="clip0_1463_824">
                              <rect width="20" height="20" fill="white" />
                            </clipPath>
                            <clipPath id="clip1_1463_824">
                              <rect width="18" height="18" fill="white" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 1 18)" />
                            </clipPath>
                          </defs>
                        </svg>
                      )}
                    </span>
                    <span>{tag.count > 0 ? `(${tag.count})` : ""}</span>
                  </>
                )}
              </Link>
            ))
            : ""}
        </div>
      </div>
    </div>
  );
};

export default Card;